import { ReactComponent as Logo } from '../../../static/img/Logo.svg'

export default Logo
